import { ExportOutlined, SwapOutlined } from '@ant-design/icons';
import React, { useState } from 'react'
import { useListarObjetos } from '../../../../../../Hooks/Admin';
import { message } from 'antd';

export const useFormularioObjetos = () => {
    //const [objetos, setObjetos] = useState([])

    const objetos = useListarObjetos();

    const columnas = [
        {
            title: "Objeto",
            dataIndex: "nombre",
            width: "20%",
        },
        {
            title: "Descripcion",
            dataIndex: "descripcion",
            width: "40%",
        },
        {
            title: "Cantidad",
            dataIndex: "cantidad",
            width: "20%",
        },
    ];

    const camposFormulario = {
        title: "Usuario",
        campos: [
            {
                name: "nombre",
                label: "Objeto",
                type: "text"
            },
            {
                name: "descripcion",
                label: "Descripción",
                type: "text",
            },
            {
                name: "consumible",
                label: "Es consumible",
                type: "checkbox",
                valuePropName: "checked"
            },
            {
                name: "gacha",
                label: "De gachapon",
                type: "checkbox",
                valuePropName: "checked"
            },
        ]
    };

    const acciones = (onAddItem) => {
        return [
            {
                label: "Editar cantidad",
                key: 1,
                icon: <SwapOutlined />,
                onClick: (e) => {
                    onAddItem(e)
                }
            }
        ]
    }

    const camposFormularioCrear = (idUsuario) => {
        return {
            title: "Añadir objeto",
            campos: [
                {
                    name: "idUsuario",
                    label: "Id del usuario",
                    type: "number",
                    defaultValue: idUsuario,
                    disabled: true,
                    hidden: true,
                    rules: [
                        {
                            required: true,
                            message: "Campo requerido",
                        }
                    ],
                },
                {
                    name: "idObjeto",
                    label: "Objeto",
                    type: "select",
                    opciones: objetos?.data ?? [],
                    rules: [
                        {
                            required: true,
                            message: "Campo requerido",
                        }
                    ],
                },
                {
                    name: "cantidad",
                    label: "Cantidad",
                    type: "number",
                    rules: [
                        {
                            required: true,
                            message: "Campo requerido",
                        },
                        {
                            type: "number",
                            min: 1,
                            max: 999999,
                            message: "El tier debe ser un número entre 1 y 999999",
                        },
                    ],
                }
            ]
        }
    }

    const camposFormularioEditar = {
        title: "Editar cantidad de objeto",
        campos: [
            {
                name: "idUsuario",
                label: "ID Usuario",
                type: "number",
                hidden: true,
            },
            {
                name: "idObjeto",
                label: "ID Objeto",
                type: "number",
                hidden: true,
            },
            {
                name: "idObjetoObtenido",
                label: "ID",
                type: "number",
                hidden: true,
            },
            {
                name: "cantidad",
                label: "Cantidad",
                type: "number",
                rules: [
                    {
                        required: true,
                        message: "La cantidad es obligatoria",
                    },
                    {
                        type: "number",
                        min: 0,
                        max: 999999,
                        message: "El tier debe ser un número entre 0 y 999999",
                    },
                ],
            }
        ]
    }

    const formatData = (data) => {
        return {
            idUsuario: data.usua_id,
            idObjeto: data.idObjeto,
            idObjetoObtenido: data.idObjetoUsuario,
            cantidad: data.cantidad,
        };
    };

    return {
        camposFormulario,
        columnas,
        camposFormularioCrear,
        camposFormularioEditar,
        formatData,
        acciones
    }
}
